import { TStatus } from './quality_metric_section/percent_metric/types';
import { TStatus as TS } from './quality_metric_section/status_metric/types';
import { TScore } from './video_scoring_section/types';
import { TCreativeTranslation } from '../../../redux/creativeAnalytics/creativeVideoDetails/types';

export const getInfo = (
  percent: number,
  array: TStatus[] | TS[] | TScore[]
): TStatus | TS | TScore | undefined => {
  for (let i = 0; i < array.length; i++) {
    const metric = array[i];
    if (percent >= metric.min && percent <= metric.max) {
      return metric;
    }
  }
};

export const getTranslationNode = (
  node?: TCreativeTranslation[] | string,
  currentTranslation: string = 'en'
) => {
  if (typeof node === 'string') return node;
  const currentNode = node?.map(
    (translation) =>
      translation[currentTranslation as keyof TCreativeTranslation] ?? ''
  );
  return !currentNode?.length ? '' : currentNode.join(' ');
};
